<template>
    <v-form ref="form_referencia_financiera">
        <v-container fluid grid-list-md v-show="_.size(listGeneral.cabeceraReferenciaFinanciera) > 0">
            <v-row dense>
                <v-col cols="12" sm="12">
                    <v-dialog v-model="abrirModal" :max-width="tamModal" :fullscreen="$root.isTouch"
                        :scrollable="$root.isTouch == false" persistent>
                        <template v-slot:activator="{ on }">
                            <div class="text-right">
                                <v-btn rounded dark color="primary" v-on="on">Nuevo</v-btn>
                            </div>
                        </template>
                        <v-card>
                            <v-card-title class="bg-title-card">
                                <span class="white--text headline" v-html="titulo"></span>
                            </v-card-title>
                            <v-container fluid grid-list-md>
                                <v-form ref="form_modal_referencia_financiera">
                                    <v-row dense>
                                        <v-col cols="12" sm="6">
                                            <v-autocomplete label="Tipo Cuenta *" color="textbox"
                                                v-model="objeto.idTipoCuenta" :items="listGeneral.listaTipoCuenta"
                                                item-value="idTipoCuenta" item-text="cuenta" autocomplete
                                                :rules="requeridoRegla" outlined dense> </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field label="Número Cuenta *" color="textbox"
                                                v-model="objeto.nroCuenta" :rules="_.concat(requeridoRegla,numeroRegla)"
                                                outlined dense></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-col cols="12" sm="6">
                                            <v-autocomplete label="Institución Financiera *" color="textbox"
                                                v-model="objeto.idInstitucionFinanciera"
                                                :items="listGeneral.listaInstitucion"
                                                item-value="idInstitucionFinanciera" item-text="institucion"
                                                :rules="requeridoRegla" outlined dense></v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-col cols="12" sm="12" class="text-right mt-3 mb-3">
                                            <v-btn outlined dense rounded color="danger" class="mr-1" @click="reset">
                                                Cancelar</v-btn>
                                            <v-btn rounded dark color="primary" @click="validarModal">Guardar</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-card>
                    </v-dialog>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="6"/>
                <v-col cols="12" sm="6">
                    <v-text-field label="Buscar" color="textbox" v-model="objeto.busqueda" prepend-inner-icon="search"
                        dense>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="12">
                    <v-data-table :search="objeto.busqueda" :headers="listGeneral.cabeceraReferenciaFinanciera"
                        :items="listGeneral.listaReferenciaFinanciera" class="elevation-3">

                        <template v-slot:item.name="{ item }">
                            <v-btn class="ma-2" text icon color="primary" @click="onEditar(item)">
                                <v-icon small>edit</v-icon>
                            </v-btn>
                        </template>

                        <template v-slot:no-results>
                            Tu búsqueda de "<span v-text="objeto.busqueda"></span>" no arrojó resultados.
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="12" class="text-right mt-3 mb-3">
                    <v-btn outlined dense rounded color="danger" class="mr-1" @click="previous('objRefBan',this.objForm);">Anterior</v-btn>
                    <v-btn rounded dark color="primary" @click="validar">Siguiente</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    export default {
        name: 'StepperReferenciaFinancieraComponent',
        inject: ['previous', 'next', 'onListarCatalogo'],
        props: {
            cargar: {
                type: Boolean,
                default: false
            },
            objForm: {
                type: Object,
                default: {}
            },
            listGeneral: {
                type: Object,
                default: {}
            },
        },
        data: () => ({
            abrirModal: false,
            titulo: 'Nueva Referencia Institución Financiera',
            objeto: {
                idTipoCuenta: null
            }
        }),
        watch: {
            cargar(val) {
                if (val && _.size(this.listGeneral.listaReferenciaFinanciera) == 0) {
                    this.objeto = _.clone(this.objForm);

                    var request = [
                        this.onListarCatalogo('TIPO_CUENTA', 'listaTipoCuenta'), 
                        this.onListarCabecera(),
                        this.onListarInstitucionFinanciera()
                    ];

                    Promise.all(request)
                           .then((respuesta) => {
                                var l = _.filter(_.get(this.listGeneral,'listaTipoCuenta',[]),{'visualiza':'true'});
                                this.listGeneral.listaTipoCuenta = l;
                            return this.onListarDetalle();
                        });
                }
            }
        },
        methods: {
            onListarCabecera() {
                this.listGeneral.cabeceraReferenciaFinanciera = [];
                var objeto = { opcion: 'CAB_REFERENCIA_FINANCIERA' };
                var error = 'E';

                return axios.post(`${BASE_URI}administrador/prevension-lavado-activo/cliente/listar`,objeto)
                            .then((r) => {
                                if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                if (_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }                                
                                    this.$set(this.listGeneral, 'cabeceraReferenciaFinanciera', r.data.data);
                                return r;
                            })
                            .catch((e)=>{
                                mensajesAlerta(e, error);
                                return e;
                            });
            },
            onListarDetalle() {
                var objeto = {
                    opcion: 'LISTAR_REFERENCIA_FINANCIERA',
                    idFormulario: this.objeto.idFormulario,
                    idCliente: _.get(this.objeto, 'idCliente', null),
                    idContratante: _.get(this.objeto, 'idContratante', null)
                };
                var error = 'E';

                return axios.post(`${BASE_URI}administrador/prevension-lavado-activo/cliente/listar`,objeto)
                            .then((r) => {
                                if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                if (_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }  
                                    var l = _.map(r.data.data,(v)=>{
                                                    v.id = _.uniqueId();
                                                    v.index = _.toString(v.index);
                                                return v;
                                            });

                                    this.$set(this.listGeneral, 'listaReferenciaFinanciera', l);
                                return r;
                            })
                            .catch((e)=>{
                                mensajesAlerta(e, error);
                                return e;
                            });
            },
            onListarInstitucionFinanciera() {
                var error = 'E';
                var objeto = { opcion: 'LISTAR_COMBO' };

                return axios.post(`${BASE_URI}administrador/institucion-financiera/listar`,objeto)
                            .then((r) => {
                                if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                if (_.size(_.get(r,['data','data'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }  
                                    this.$set(this.listGeneral, 'listaInstitucion', r.data.data);
                                return r;
                            })
                            .catch((e)=>{
                                mensajesAlerta(e, error);
                                return e;
                            });
            },
            onEditar(obj, index) {
                this.objeto = _.merge(this.objeto, obj);
                this.titulo = 'Editar Referencia Institución Financiera';
                this.abrirModal = !this.abrirModal;
            },
            validar() {
                if (_.size(this.listGeneral.listaReferenciaFinanciera) > 0)
                    this.next('objRefBan',this.objForm);
            },
            validarModal() {
                if (this.$refs.form_modal_referencia_financiera.validate()) {
                    var l = this.listGeneral.listaReferenciaFinanciera;
                    this.objeto.tipoCuenta  = _.get(_.find(this.listGeneral.listaTipoCuenta,{'idTipoCuenta':this.objeto.idTipoCuenta}),'cuenta',null);
                    this.objeto.institucion = _.get(_.find(this.listGeneral.listaInstitucion,{'idInstitucionFinanciera':this.objeto.idInstitucionFinanciera}),'institucion',null);

                    if(_.size(this.objeto.id) == 0){
                        var v = _.merge({}, this.objeto, {'id': _.uniqueId()});
                        l.push(v);
                    }
                    else {
                        var pos = _.findIndex(l,{'id':this.objeto.id});
                        l[pos] = _.merge(l[pos], this.objeto);
                    }
                    this.next('listaReferenciaFinanciera',l,false);
                    this.reset();
                }
            },
            reset() {
                if(!_.isUndefined(this.$refs.form_modal_referencia_financiera))
                    this.$refs.form_modal_referencia_financiera.resetValidation();

                this.titulo = 'Nueva Referencia Institución Financiera';
                this.objeto = _.clone(this.objForm);
                this.abrirModal = false;
            }
        }
    }
</script>